import { EventTriggerSource } from '@enums';
import { FlowModuleFragment } from '@graphql/generated/graphql';
import { FC } from 'react';

import { FlowRenderer } from './FlowRenderer';
import { FlowProvider } from '../contexts/FlowContext';

interface Props {
    module: FlowModuleFragment;
    triggerSource: EventTriggerSource;
    onExit?: () => void;
}

export const Flow: FC<Props> = ({ module, triggerSource, onExit }) => (
    <FlowProvider module={module} triggerSource={triggerSource} onExit={onExit}>
        <FlowRenderer />
    </FlowProvider>
);
